import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { posthog } from "@/lib/posthog";

export default function PostHogPageview() {
  const location = useLocation();
  useEffect(() => {
    posthog.capture("$pageview", {
      $current_url: window.location.href,
      path: location.pathname,
      app: "inner-path",
      app_name: "inner-path",
    });
  }, [location.pathname, location.search]);
  return null;
}
